/* Source: /home/ubuntu/libredraw/lib/utils.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return String(twMerge(clsx(inputs)));
}
export {cn};
//# sourceMappingURL=utils.js.map
